import filterUtils from 'app/shared/utils/filterUtils';
import { fetchTopMarkets } from 'app/shared/flux/actions/AreaActions';
import { logError } from '@zg-rentals/log-error';

const serverRouteWillMount = ({ store }: { store: any }) => {
  // fetch top markets and save in redux store
  const { dispatch } = store;
  const state = store.getState();
  const queryString = state.router.location.search;
  const filterParams = filterUtils.queryStringToApiParams(queryString);

  return (
    dispatch(fetchTopMarkets(filterParams))
      // @ts-ignore
      .catch((err) => {
        logError({
          error: err,
          errorType: 'MarketTrends',
          context: {
            details: 'Market Stats Page: Error fetching Top Markets (SSR)',
            root: 'pages/MarketTrendsPage#serverRouteWillMount',
          },
        });
      })
  );
};

export default serverRouteWillMount;
